import { find } from "lodash";

/*
 * groupIndex used to sort page group in user config page
 * groupIndex = null :
 * 1) default page : all users has permission
 * 2) group
 *
 *
 * groupId :
 * Indicate which group the page belongs to
 */

export const permissionCodes = [
  {
    id: 0,
    groupIndex: null,
    name: "login", 
    nameC: "登入",
    nameE: "Login",
  },
  {
    id: 3,
    name: "court-root",
    groupIndex: null,
    nameC: "首頁",
    nameE: "Homepage",
  },
  {
    id: 4,
    name: "court-home",
    groupIndex: null,
    nameC: "實時監測",
    nameE: "Current Map",
  },
  {
    id: 6,
    name: "trip-viewer",
    nameC: "行程追溯",
    nameE: "History Trips",
    groupC: "行車紀錄",
    groupE: "Trip Records",
    groupId: 57,
    groupIndex: 0,
    isTd: false,
  },
  {
    id: 14,
    name: "trip-replay",
    nameC: "行車軌跡",
    nameE: "Trip Replay",
    groupC: "行車紀錄",
    groupE: "Trip Records",
    groupId: 57,
    groupIndex: 0,
    isTd: false,
  },
  {
    id: 70,
    name: "s3-archive",
    nameC: "過去數據",
    nameE: "Past Data Archive",
    groupC: "行車紀錄",
    groupE: "Trip Records",
    groupId: 57,
    groupIndex: 0,
    isTd: true,
  },
  {
    id: 17,
    name: "route-management",
    nameC: "路線設定",
    nameE: "Route Management",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: true,
  },
  {
    id: 21,
    name: "error-report",
    nameC: "錯誤報表",
    nameE: "Error Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 27,
    name: "device-config",
    nameC: "裝置設定",
    nameE: "Device Config",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: true,
  },
  {
    id: 31,
    name: "gmb-config",
    nameC: "小巴設定",
    nameE: "GMB Config",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: true,
  },
  {
    id: 32,
    name: "geo-fencing",
    nameC: "電子圍欄",
    nameE: "Geo-fencing",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: false,
  },
  {
    id: 36,
    name: "arrival-timetable",
    nameC: "到站時間表",
    nameE: "Arrival Timetable",
    groupC: "其他",
    groupE: "Other",
    groupIndex: 5,
    isTd: false,
  },
  {
    id: 37,
    name: "offline-report",
    nameC: "離線報表",
    nameE: "Offline Report",
    groupC: "系統異常報表",
    groupE: "Service Exception Reports",
    groupIndex: 3,
    groupId: 54,
    isTd: false,
  },
  {
    id: 38,
    name: "miles-report",
    nameC: "里數報表",
    nameE: "Miles Report",
    groupC: "營運報表",
    groupE: "Operation Reports",
    groupId: 52,
    groupIndex: 1,
    isTd: false,
  },
  {
    id: 39,
    name: "out-of-route-report",
    nameC: "偏離路線報表",
    nameE: "Out of Route Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 41,
    name: "vehicle-allocation-report",
    nameC: "車輛編配報表",
    nameE: "Vehicle Allocation Report",
    groupC: "營運報表",
    groupE: "Operation Reports",
    groupId: 52,
    groupIndex: 1,
    isTd: false,
  },
  {
    id: 42,
    name: "operator-config",
    nameC: "營運商設定",
    nameE: "Operator Config",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: true,
  },
  {
    id: 43,
    name: "user-config",
    nameC: "用戶設定",
    nameE: "User Config",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: false,
  },
  {
    id: 44,
    name: "ffnd-report",
    nameC: "全車隊未能接收數據報表",
    nameE: "Full Fleet No Data Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 45,
    name: "rsl-report",
    nameC: "同一位置報表",
    nameE: "Remain at the Same Location Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 46,
    name: "journey-time-report",
    nameC: "行車時間報表",
    nameE: "Journey Time Report",
    groupC: "營運報表",
    groupE: "Operation Reports",
    groupId: 52,
    groupIndex: 1,
    isTd: false,
  },
  {
    id: 47,
    name: "journey-time-exception-report",
    nameC: "行車時間異常報表",
    nameE: "Journey Time Exception Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 48,
    name: "add-route",
    nameC: "新增路線",
    nameE: "Add Route",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: true,
  },
  {
    id: 49,
    name: "operation-summary-report",
    nameC: "營運總覽",
    nameE: "Operation Summary Report",
    groupC: "營運報表",
    groupE: "Operation Reports",
    groupId: 52,
    groupIndex: 1,
    isTd: false,
  },
  {
    id: 50,
    name: "schedule-config",
    nameC: "班次設定",
    nameE: "Schedule Config",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 4,
    isTd: false,
  },
  {
    id: 51,
    name: "management",
    groupIndex: null,
    nameC: "管理",
    nameE: "Management",
  },
  {
    id: 52,
    name: "operating-report",
    groupIndex: null,
    nameC: "營運報表",
    nameE: "Operating Report",
  },
  {
    id: 53,
    name: "service-exception-report",
    groupIndex: null,
    nameC: "服務異常報表",
    nameE: "Service Exception Report",
  },
  {
    id: 54,
    name: "system-exception-report",
    groupIndex: null,
    nameC: "系統異常報表",
    nameE: "System Exception Report",
  },
  {
    id: 57,
    name: "historical-trip",
    groupIndex: null,
    nameC: "運作報表",
    nameE: "Historical Trip",
  },
  {
    id: 55,
    name: "exception-summary-report",
    nameC: "服務異常報表",
    nameE: "Exception Summary Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 56,
    name: "speeding-report",
    nameC: "超速報表",
    nameE: "Speeding Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 64,
    name: "oor-hour-report",
    nameC: "營運時間異常報表",
    nameE: "Out of Operating Hours Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 65,
    name: "oor-day-report",
    nameC: "營運日子異常報表",
    nameE: "Out of Operating Days Report",
    groupC: "服務異常報表",
    groupE: "Exception Reports",
    groupId: 53,
    groupIndex: 2,
    isTd: false,
  },
  {
    id: 67,
    name: "departure-arrival-report",
    nameC: "班次報表",
    nameE: "Departure Report",
    groupC: "營運報表",
    groupE: "Operation Reports",
    groupId: 52,
    groupIndex: 1,
    isTd: false,
  },
  {
    id: 68,
    name: "temp-disable-eta",
    nameC: "臨時停用到站預報",
    nameE: "Temporary Disable ETA",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 5,
    isTd: true,
  },
  {
    id: 69,
    name: "temp-disable-eta-individual",
    nameC: "臨時停用到站預報（個別路線/車站）",
    nameE: "Temporary Disable ETA (Individial Route/Stop)",
    groupC: "管理",
    groupE: "Management",
    groupId: 51,
    groupIndex: 5,
    isTd: true,
  },
  {
    id: 99,
    name: "ldd-installation",
    nameC: "安裝裝置",
    nameE: "LDD Installation",
    groupC: "其他",
    groupE: "Other",
    groupIndex: 5,
    isTd: true,
  },
];

export const getPermissionCode = (name) => {
  const permission = find(permissionCodes, { name });
  if (permission) {
    return permission.id;
  }
  return -1;
};

export const allowRedirect = (name, userPermissions) => {
  const code = getPermissionCode(name);
  if (userPermissions.includes(code)) {
    return true;
  }
  if (
    localStorage
      .getItem("permissions")
      .split(",")
      .map((ele) => parseInt(ele))
      .includes(code)
  ) {
    return true;
  }
  return false;
};

export const redirect = (history, link, name, userPermissions) => {
  // console.log({ history, link, name, userPermissions });
  if (allowRedirect(name, userPermissions)) {
    history.push(link);
  }
};

export const determineIsTd = (state) => {
  if (state.isTd) {
    return state.isTd;
  }
  if (localStorage.getItem("isTd")) {
    return true;
  }
  return false;
};

export const determineUserGroupId = (state) => {
  return state.userGroupId || localStorage.getItem("userGroupId");
};

export const determineIsMegaOp = (state) => {
  if (state.isMegaOp) {
    return state.isMegaOp;
  }
  if (localStorage.getItem("isMegaOp")) {
    return true;
  }
  return false;
};

export const determineRoutePermissionId = (state) => {
  if (state.routePermissionId) {
    return state.routePermissionId;
  }

  if (localStorage.getItem("routePermissionId")) {
    return localStorage.getItem("routePermissionId");
  }

  return null;
};

export const getOperatorId = (state) => {
  if (state.operatorId) return state.operatorId;

  if (localStorage.getItem("operatorId"))
    return localStorage.getItem("operatorId");

  return null;
};

export const getPermission = (state) => {
  let permissions = [];
  if (state.permissions.length > 0) {
    permissions = state.permissions;
  } else if (localStorage.getItem("permissions")) {
    permissions = localStorage
      .getItem("permissions")
      .split(",")
      .map((ele) => parseInt(ele));
  }
  return permissions;
};
